export const DESKTOP_WIDTH = 992
const MIDDLE_WIDTH = 800
export const MOBILE_WIDTH = 576

export default {
  desktop: `@media screen and (min-width: ${DESKTOP_WIDTH + 1}px)`,
  tablet: `@media screen and (min-width: ${
    MOBILE_WIDTH + 1
  }px) and (max-width: ${DESKTOP_WIDTH}px)`,
  mobile: `@media screen and (max-width: ${MOBILE_WIDTH}px)`,
  mobileTablet: `@media screen and (max-width: ${DESKTOP_WIDTH}px)`,
  tabletDesktop: `@media screen and (min-width: ${MOBILE_WIDTH + 1}px)`,
  mobileMiddle: `@media screen and (max-width: ${MIDDLE_WIDTH}px)`,
}
